import shortid from 'shortid';
import portalCommunication from '@3plearning/mathletics-portal-communication-service';
import Resources from '../../helpers/resources';

import { SHOW_CONFIRM_MODAL } from '../../containers/confirmation-modal/confirmation-modal-actions';
import { SHOW_TOAST } from '../../components/toast/actions';
import { UPDATE_CLASS_LIST } from '../../containers/whole-class/whole-class-actions';
import { findItem, navigateToModule, getLocale } from '../../helpers/utils';

// region actions
export const ACTIONED = 'ACTIONED';
export const UPDATE_TITLE = 'UPDATE_TITLE';
export const FOOTER_BUTTONS_SETUP = 'FOOTER_BUTTONS_SETUP';
export const UPDATE_GROUP_LIST = 'UPDATE_GROUP_LIST';
export const UPDATE_CLASS_LIST_STUDENT = 'UPDATE_CLASS_LIST_STUDENT';
export const UPDATE_STUDENT_LIST_STUDENT = 'UPDATE_STUDENT_LIST_STUDENT';
export const UPDATE_SELECTED_CLASS_GROUP = 'UPDATE_SELECTED_CLASS_GROUP';
export const UPDATE_QUERY_PARAMS = 'UPDATE_QUERY_PARAMS';
export const MODULE_CHANGE_REQUESTED = 'MODULE_CHANGE_REQUESTED';

// endregion

// region Student management Actions

export const UPDATE_SCHOOL_FILTERS = 'UPDATE_SCHOOL_FILTERS';
export const UPDATE_SCHOOL_STUDENTS_STUDENTS = 'UPDATE_SCHOOL_STUDENTS_STUDENTS';
export const UPDATE_CLASSROOM_NAME = 'UPDATE_CLASSROOM_NAME';
export const SELECT_SCHOOL_CLASS = 'SELECT_SCHOOL_CLASS';
export const SELECT_SCHOOL_GROUP = 'SELECT_SCHOOL_GROUP';
export const UPDATE_STUDENT_LIST_SELECTION = 'UPDATE_STUDENT_LIST_SELECTION';
export const UPDATE_AVAILABLE_STUDENT_LIST_SELECTION = 'UPDATE_AVAILABLE_STUDENT_LIST_SELECTION';
export const SELECT_ALL_STUDENTS = 'SELECT_ALL_STUDENTS';
export const SELECT_ALL_AVAILABLE_STUDENTS = 'SELECT_ALL_AVAILABLE_STUDENTS';
export const UPDATE_SURNAME_FILTER_STUDENT = 'UPDATE_SURNAME_FILTER_STUDENT';
export const UPDATE_YEAR_GROUP_FILTER_STUDENT = 'UPDATE_YEAR_GROUP_FILTER_STUDENT';
export const RESET_UNASSIGNED_RESOURCE = 'RESET_UNASSIGNED_RESOURCE';
export const GET_SELECTED_STUDENTS_POST_MOVECOPY = 'GET_SELECTED_STUDENTS_POST_MOVECOPY';


// endregion

// region update
export const updateClassGroupId = (classId, groupId) => async (dispatch) => {
    dispatch({
        type: UPDATE_SELECTED_CLASS_GROUP,
        payload: {
            selectedClassId: classId,
            selectedGroupId: groupId
        }
    });
};

export const updateAvailableStudentListSelection = (student, value) => async (dispatch) => {
    // call resource here
    student.selected = value;
    dispatch({
        type: UPDATE_AVAILABLE_STUDENT_LIST_SELECTION,
        payload: {
            student
        }
    });
};

export const moveOrCopyStudents = commandInfo => async (dispatch) => {
    const { students, classId, groupId,
        availableClassId, availableGroupId, surnameGroupId, yearGroupId, productId, message } = commandInfo;
    const studentProfileIds = students.map(item => (item.userProfileId));
    const changeAllocation = {
        sourceClassId: availableClassId,
        studentProfileIds,
        removeFromSourceClass: commandInfo.action === 'move'
    };

    const params = cleanArray({
        availableClassId,
        availableGroupId,
        surnameGroupId,
        yearGroupId
    });

    const resource = await Resources.assignStudents
        .patch({ classId, groupId, productId })
        .withBody(changeAllocation)
        .withParams(params)
        .headers({ Locale: getLocale() })
        .send()
    ;
    const data = resource.data;
    data.classGroupStudents.map(item =>
        studentProfileIds.map((student) => {
            if (item.userProfileId === student) {
                item.isMovedCopied = true;
            }
            return true;
        })
    );
    dispatch({
        type: RESET_UNASSIGNED_RESOURCE
    });
    dispatch({
        type: UPDATE_SCHOOL_STUDENTS_STUDENTS,
        payload: {
            availableClassGroupStudents: generateKeys(data.availableClassGroupStudents)
        }
    });
    dispatch({
        type: UPDATE_STUDENT_LIST_STUDENT,
        payload: {
            classGroupStudents: generateKeys(data.classGroupStudents)
        }
    });
    dispatch({
        type: SHOW_TOAST,
        isToastVisible: true,
        message,
        messageType: 'success'
    });
    dispatch({
        type: GET_SELECTED_STUDENTS_POST_MOVECOPY,
        payload: students.map(item => (item.userProfileId))
    });
    window.scrollTo(0, 0);
};
// endregion

// region initial loaders
export function updateTitle(title, subTitle) {
    return {
        type: UPDATE_TITLE,
        payload: {
            title,
            subTitle
        }
    };
}

export function setupButtons(leftButtons, rightButtons) {
    return {
        type: FOOTER_BUTTONS_SETUP,
        payload: {
            leftButtons,
            rightButtons
        }
    };
}

export const getAllData = (productId, classId = null, groupId = null) => async (dispatch) => {
    // call resource here
    productId = productId || 1;
    const params = cleanArray({
        classId,
        groupId
    });
    const resource = await Resources.getStudentManagementData
        .get({ productId })
        .withParams(params)
        .headers({ Locale: getLocale() })
        .send()
    ;
    const data = resource.data;

    dispatch({
        type: UPDATE_GROUP_LIST,
        payload: {
            classGroups: data.classGroups
        }
    });

    dispatch({
        type: UPDATE_STUDENT_LIST_STUDENT,
        payload: {
            classGroupStudents: generateKeys(data.classGroupStudents)
        }
    });

    dispatch({
        type: UPDATE_SCHOOL_FILTERS,
        payload: {
            surnames: data.surnameGroups,
            yearGroups: data.yearGroups,
            availableClasses: data.availableClasses,
            availableClassGroups: data.availableClassGroups,
            selectedClassId: data.classId,
            selectedGroupId: data.classGroupId,
            availableClassId: data.availableClassId,
            availableClassGroupId: data.availableClassGroupId,
            classList: data.classes
        }
    });

    dispatch({
        type: UPDATE_SCHOOL_STUDENTS_STUDENTS,
        payload: {
            availableClassGroupStudents: generateKeys(data.availableClassGroupStudents)
        }
    });
    const classroomName = findItem(data.classes, data.classId) ? findItem(data.classes, data.classId).name : null;
    dispatch({
        type: UPDATE_CLASSROOM_NAME,
        payload: {
            classroomName
        }
    });
};
// endregion

// region available-students-filter
export const toggleSelectAllAvailableStudents = value => async (dispatch) => {
    dispatch({
        type: SELECT_ALL_AVAILABLE_STUDENTS,
        payload: {
            value
        }
    });
};

export const selectSurname = (productId, surnameGroupId, classId, groupId = 0, yearGroupId) => async (dispatch) => {
    const params = cleanArray({
        yearGroupId,
        surnameGroupId
    });
    const resource = await Resources.getStudentManagementAvailableGroups
        .get({ productId, classId, groupId })
        .withParams(params)
        .send()
    ;
    const data = resource.data;
    dispatch({
        type: UPDATE_SURNAME_FILTER_STUDENT,
        payload: {
            availableSurnameId: surnameGroupId,
            availableClassGroupStudents: generateKeys(data)
        }
    });
};

export const selectYearGroup = (productId, yearGroupId, classId, groupId = 0, surnameGroupId) => async (dispatch) => {
    const params = cleanArray({
        yearGroupId,
        surnameGroupId
    });
    const resource = await Resources.getStudentManagementAvailableGroups
        .get({ productId, classId, groupId })
        .withParams(params)
        .send()
    ;
    const data = resource.data;
    dispatch({
        type: UPDATE_YEAR_GROUP_FILTER_STUDENT,
        payload: {
            availableYearGroupId: yearGroupId,
            availableClassGroupStudents: generateKeys(data)
        }
    });
};

export const selectSchoolClass = (productId, classId, surnameId, yearGroupId) => async (dispatch) => {
    const params = cleanArray({
        yearGroupId,
        surnameGroupId: surnameId
    });

    const resource = await Resources.getStudentManagementAvailableClasses
        .get({ productId, classId })
        .withParams(params)
        .headers({ Locale: getLocale() })
        .send()
    ;
    const data = resource.data;
    dispatch({
        type: UPDATE_SCHOOL_FILTERS,
        payload: {
            availableClassGroups: data.classGroups,
            availableClassId: classId,
            availableClassGroupId: data.classGroupId
        }
    });

    dispatch({
        type: UPDATE_SCHOOL_STUDENTS_STUDENTS,
        payload: {
            availableClassGroupStudents: generateKeys(data.classGroupStudents)
        }
    });
};

export const selectSchoolGroup = (productId, classId, groupId, surnameGroupId, yearGroupId) => async (dispatch) => {
    const params = cleanArray({
        yearGroupId,
        surnameGroupId
    });
    // call resource here
    const resource = await Resources.getStudentManagementAvailableGroups
        .get({ productId, classId, groupId })
        .withParams(params)
        .headers({ Locale: getLocale() })
        .send()
    ;
    const data = resource.data;
    dispatch({
        type: UPDATE_SCHOOL_FILTERS,
        payload: {
            availableClassId: classId,
            availableClassGroupId: groupId
        }
    });
    dispatch({
        type: UPDATE_SCHOOL_STUDENTS_STUDENTS,
        payload: {
            availableClassGroupStudents: generateKeys(data)
        }
    });
};
// endregion

// region class-group-students
export const selectClass = (productId, classId) => async (dispatch) => {
    // call resource here
    const resource = await Resources.getStudentManagementClasses
        .get({ productId, classId })
        .headers({ Locale: getLocale() })
        .send()
    ;
    const data = resource.data;
    portalCommunication.informClassGroupSelection(classId);
    dispatch({
        type: UPDATE_GROUP_LIST,
        payload: {
            classGroups: data.classGroups,
            classGroupId: data.classGroupId
        }
    });

    dispatch({
        type: UPDATE_STUDENT_LIST_STUDENT,
        payload: {
            classGroupStudents: generateKeys(data.classGroupStudents)
        }
    });

    updateClassGroupId(classId, data.classGroupId)(dispatch);
};

export const selectGroup = (productId, classId, groupId) => async (dispatch) => {
    // call resource here
    // getStudentManagementClasses
    const resource = await Resources.getStudentManagementGroups
        .get({ productId, classId, groupId })
        .headers({ Locale: getLocale() })
        .send()
    ;
    const data = resource.data;
    portalCommunication.informClassGroupSelection(classId, groupId);
    dispatch({
        type: UPDATE_STUDENT_LIST_STUDENT,
        payload: {
            classGroupStudents: generateKeys(data)
        }
    });

    updateClassGroupId(classId, groupId)(dispatch);
};

export const toggleSelectAllStudents = value => async (dispatch) => {
    dispatch({
        type: SELECT_ALL_STUDENTS,
        payload: {
            value
        }
    });
};

export const updateStudentListSelection = (student, value) => async (dispatch) => {
    // call resource here
    student.selected = value;
    dispatch({
        type: UPDATE_STUDENT_LIST_SELECTION,
        payload: {
            student
        }
    });
};

export const displayUnassign = bePlural => async (dispatch) => {
    dispatch({
        type: SHOW_CONFIRM_MODAL,
        payload: {
            displayInfo: {
                type: 'display-unassign-student',
                bePlural
            }
        }
    });
};

export const unassign = (productId, classId, groupId, students, query) => async (dispatch) => {
    const { availableClassId, availableGroupId, surnameGroupId, yearGroupId, message } = query;
    const studentProfileIds = students.map(item => (item.userProfileId));
    const params = cleanArray({
        availableClassId,
        availableGroupId,
        surnameGroupId,
        yearGroupId
    });

    const resource = await Resources.unassignStudents
        .patch({ productId, classId, groupId })
        .withBody(studentProfileIds)
        .withParams(params)
        .headers({ Locale: getLocale() })
        .send()
    ;
    const data = resource.data;
    dispatch({
        type: RESET_UNASSIGNED_RESOURCE
    });
    dispatch({
        type: UPDATE_SCHOOL_STUDENTS_STUDENTS,
        payload: {
            availableClassGroupStudents: generateKeys(data.availableClassGroupStudents)
        }
    });
    dispatch({
        type: UPDATE_STUDENT_LIST_STUDENT,
        payload: {
            classGroupStudents: generateKeys(data.classGroupStudents)
        }
    });
    dispatch({
        type: SHOW_TOAST,
        isToastVisible: true,
        message,
        messageType: 'success'
    });
    window.scrollTo(0, 0);
};
// endregion

export function actionCreator(payload) {
    return {
        type: ACTIONED,
        payload
    };
}

export const navigateBtnClick = (history, item) => (dispatch) => {
    navigateToModule(item.type, {
        // ...params,
        sourceModule: 'whole-class'
    });
    dispatch({
        type: UPDATE_QUERY_PARAMS,
        payload: {
            sourceModule: 'whole-class'
        }
    });
    dispatch({
        type: UPDATE_CLASS_LIST,
        payload: {
            classList: undefined
        }
    });
    history.push(item.toUrl);
    dispatch({
        type: RESET_UNASSIGNED_RESOURCE
    });
};

export const navigateToPortalModule = (moduleId, params) => (dispatch) => {
    portalCommunication.requestModuleChange(moduleId, params);
    dispatch({
        type: MODULE_CHANGE_REQUESTED,
        payload: {
            moduleId,
            params
        }
    });
};

function generateKeys(list) {
    return list.map((item) => {
        item.key = shortid.generate();
        return item;
    });
}

function cleanArray(actual) {
    return JSON.parse(JSON.stringify(actual));
}




// WEBPACK FOOTER //
// ./containers/students/students-actions.js